import { lazadaServiceLinkMap } from 'views/Refund/utils/constants';
import { ReturnActionsProps } from './types';
import toLowerCase from 'utils/toLowerCase';
import { Button } from 'antd';
import { goPlatform } from 'views/Refund/utils/store';
import { useTranslate } from '@tolgee/react';

export const ReturnActionLazada = (props: ReturnActionsProps) => {
  const {
    row: { internalStoreId, region },
  } = props;
  const { t } = useTranslate();

  const serviceLink = lazadaServiceLinkMap[toLowerCase(region)];

  return serviceLink ? (
    <Button
      type="link"
      size="small"
      className="contact-lazada"
      onClick={() => goPlatform(internalStoreId)}
    >
      {t('scene.orderWorkspace.cancelOrderTab.action.contactLazada')}
    </Button>
  ) : null;
};
